<template>
  <el-dialog
    title="查看网络拓扑"
    :visible="showViewNetPlane"
    :show-close="true"
    fullscreen
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    width="80%">
    <div id="container" :style="{height:mapHeight +'px'}"></div>
  </el-dialog>
</template>

<script>
  import * as echarts from 'echarts'
  import { mapState } from 'vuex';
    export default {
        name: "ViewNetPlane",
      data() {
        return {
          myChart:null,
          mapHeight:500,
          nodeData: [],
          nodeLinks: [],
          count: 1,
          r: 30
        }
      },
      computed: {
        ...mapState('main', ['tableHeight'])
      },
      methods: {
        handleClose(){
          this.$emit('editCallback')
        },
        initMap(){
          let _this = this;
          let chartDom = document.getElementById('container')
          _this.myChart = echarts.init(chartDom)
          let option = {
            // title: {
            //   text: 'Basic Graph'
            // },
            tooltip: {},
            animationDurationUpdate: 1500,
            animationEasingUpdate: 'quinticInOut',
            series: [
              {
                type: 'graph',
                layout: 'none',
                symbolSize: 50,
                roam: true,
                label: {
                  show: true
                },
                edgeSymbol: ['circle', 'arrow'],
                edgeSymbolSize: [4, 10],
                edgeLabel: {
                  fontSize: 20
                },
                data: _this.nodeData,
                // links: [],
                links: _this.nodeLinks,
                lineStyle: {
                  opacity: 0.9,
                  width: 2,
                  curveness: 0,
                }
              }
            ]
          };
          this.myChart.setOption(option);

        },
        initData() {
          var data = {
            'id': this.viewNetPlaneItme.id
          };
          var _this = this;

          this.$axios.post(this.baseUrl3 + 'management3/netplane/netplaneaccesslist', data)
            .then(({data: {msg, data, code}}) => {
              if (code == 20000) {
                let npName  = this.viewNetPlaneItme.netPlaneName + "(0)";
                _this.nodeData.push({
                  name: npName,
                  itemStyle: {
                    color: '#27e497',
                  },
                  x: 100,
                  y: 100
                })
                let childData = [];
                if(data && data.length > 0){
                  for(let i=0; i< data.length; i++){
                    let obj = data[i];
                    if(obj.type == 1){
                      _this.nodeData.push({
                        name: obj.netPlaneName+ "("+1+")",
                        itemStyle: {
                          color: '#FB95D5',
                        },
                        symbol:"rect",
                        x: 100 + _this.count * 20,
                        y: 50 + (i+1)*30
                      })
                    }else {
                      _this.nodeData.push({
                        name: obj.netPlaneName+ "("+1+")",
                        x: 100 + _this.count * 20 ,
                        y: 50 + (i+1)*30
                      })
                    }
                    _this.nodeLinks.push({
                      source: npName,
                      target: obj.netPlaneName+ "("+1+")",
                    })
                    if(obj.accessNetPlaneList && obj.accessNetPlaneList.length > 0){
                      childData.push({
                        level: 1+1,
                        parentName: obj.netPlaneName+ "("+1+")",
                        accessNetPlaneList: obj.accessNetPlaneList,
                        x: 100 + _this.count * 20,
                        y: 50 + (i+1)*30
                      })
                    }
                  }

                }
                if(childData.length > 0){
                  _this.handleChildData(childData)
                }
                this.$nextTick(() => {
                  this.initMap()
                })
              } else {
                _this.$message({showClose: true, message: msg, type: 'error'})
                console.log(msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        handleChildData( data ){
          let _this = this
          let childData = [];
          if(data && data.length > 0){
            for(let i=0; i< data.length; i++){
              let obj = data[i];
              let num = obj.accessNetPlaneList.length
              let d = 90/num;
              obj.accessNetPlaneList.forEach( (e,idx) => {
                let _x = obj.x + Math.sin(d *(idx +1) * (Math.PI / 180)) * _this.r;
                let _y = obj.y + Math.cos(d *(idx +1) * (Math.PI / 180)) * _this.r;
                if(e.type == 1){
                  _this.nodeData.push({
                    name: e.netPlaneName +"("+obj.level+"_"+i+")" ,
                    itemStyle: {
                      color: '#FB95D5',
                    },
                    symbol:"rect",
                    x: _x,
                    y: _y
                  })
                }else {
                  _this.nodeData.push({
                    name: e.netPlaneName +"("+obj.level+"_"+i+")" ,
                    x: _x,
                    y: _y
                  })
                }

                _this.nodeLinks.push({
                  source: obj.parentName,
                  target: e.netPlaneName +"("+obj.level+"_"+i+")",
                })

                if(e.accessNetPlaneList && e.accessNetPlaneList.length > 0){
                  childData.push({
                    level: obj.level+1,
                    parentName: e.netPlaneName +"("+obj.level+"_"+i+")",
                    accessNetPlaneList: e.accessNetPlaneList,
                    x: _x,
                    y: _y
                  })
                }


              })
            }
            if(childData.length > 0){
              _this.handleChildData(childData)
            }
          }

        }
      },
      created() {
          this.initData();
      },
      mounted() {
        this.mapHeight = this.tableHeight?this.tableHeight+20:530;


      },
      props: {
        showViewNetPlane: {
          type: Boolean
        },
        viewNetPlaneItme: {
          type: Object
        }
      },
    }
</script>

<style scoped>

</style>
